export default __webpack_public_path__ + "static/media/get-started.1327cb38.svg";